import Api from '@/script/api';
import Message from '@/script/Message'
import { fetchDouDianAccounts } from '@/script/doudianLocalLogin'

const state = {
    shopList: [],   // 店铺列表
    templateList: [], // 模板列表
}

const mutations = {
    SET_SHOP_LIST(state, data) {
        state.shopList = data;
    },
    SET_TEMPLATE_LIST(state, data) {
        state.templateList = data;
    }
}

const actions = {
    async getShopList({ commit, state }, refresh = false) {
        if (state.shopList?.length && !refresh) return;

        // 列表要显示已掉登/停用店的名字，不能只拉已登录。添加任务处再按 is_login 过滤。
        const pageSize = 500;
        let page = 1;
        let remoteTotal = Infinity;
        const all = [];
        while ((page - 1) * pageSize < remoteTotal && page <= 40) {
            let res = await fetchDouDianAccounts(Api.post.bind(Api), {
                requireLogin: false,
                status: -1,
                page,
                pageSize,
            });
            if (!res || res.code != 1) {
                if (page === 1) {
                    Message.error(res?.err || res?.msg || "获取店铺列表失败");
                }
                break;
            }
            const list = res.list || [];
            remoteTotal = parseInt((res.pager && res.pager.total) || 0, 10) || 0;
            for (let i = 0; i < list.length; i++) {
                all.push(list[i]);
            }
            if (!list.length || list.length < pageSize) {
                break;
            }
            page++;
        }
        if (all.length) {
            commit('SET_SHOP_LIST', all);
        }
    },
    async getTemplateList({ commit, state }, refresh = false) {
        if (state.templateList?.length && !refresh) return;

        let res = await Api.post("/admintooltaobaoaccount/getgoodstemplatelist", {
            page: 1,
            pageSize: 100,
        })
        if (res.code == 1) {
            commit('SET_TEMPLATE_LIST', res.list || []);
        } else {
            Message.error(res.err || res.msg);
        }
    },
}

const getters = {}

export default {
    namespaced: true, // 推荐开启命名空间
    state,
    mutations,
    actions,
    getters,
};
